import { Icon } from "@project/ui";

type PasskeyAuthButtonProps = {
  label: string;
  loadingLabel: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void | Promise<void>;
};

export function PasskeyAuthButton({
  label,
  loadingLabel,
  disabled,
  loading,
  onClick,
}: PasskeyAuthButtonProps): JSX.Element {
  const busy = Boolean(loading || disabled);
  return (
    <button
      type="button"
      disabled={busy}
      onClick={() => void onClick()}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-lg border border-outline-variant/25 bg-surface-container-lowest font-headline text-body-md font-semibold text-on-surface shadow-sm transition-all hover:bg-surface-container-low active:scale-[0.98] disabled:opacity-60"
    >
      <Icon name="ShieldCheck" size={18} aria-hidden />
      {loading ? loadingLabel : label}
    </button>
  );
}
